import axios from "axios";

// Function to get CSRF token from cookies
const getCSRFToken = () => {
  return document.cookie
    .split("; ")
    .find((row) => row.startsWith("csrftoken="))
    ?.split("=")[1];
};

// Create an Axios instance with global defaults
//
// Environment:
// - REACT_APP_API_BASE_URL: e.g. "https://portal.example.com/api" or just "/api"
//   If omitted, defaults to same-origin "/api".
const apiBaseURL = process.env.REACT_APP_API_BASE_URL || "/api";

const axiosInstance = axios.create({
  baseURL: apiBaseURL,
  withCredentials: true, // Ensures cookies (session, CSRF) are sent
});

// Add CSRF token to every request automatically
axiosInstance.interceptors.request.use(
  (config) => {
    const csrfToken = getCSRFToken();
    if (csrfToken) {
      config.headers["X-CSRFToken"] = csrfToken;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default axiosInstance;
